import Vue from "vue";
import Vuex from "vuex";
import stores from "./sisStoreIMS"

Vue.use(Vuex);
const store = new Vuex.Store(stores);
export default store;
